export default __webpack_public_path__ + "static/media/Faseem.5f2764f9.jpg";